package pt.at.oss.kotlin.manual.storage.common

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * Address Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class Address(
    var type: String? = null,
    var street: String = "",
    var buildingNumber: String = "",
    var floorNumber: String = "",
    var postCode: String = "",
    var city: String = "",
    var country: String? = null,
    var region: String? = null,
    var suite: String = "",
    var district: String = "",
    var postOfficeBox: String = "",
    var countrySubEntity: String = "",
    var otherLocalId: String = "",
    var freeText: String = ""
) : BaseRecord()
